import React from "react";


import Team from "../assets/team.jpg";
import CEOImg from "../assets/nima.png";
import CTOImg from "../assets/fran.png";
import LinkedinIcon from "../assets/linkedin-icon.svg";
import TriangularUp from "../assets/triangular-bg-mission-up.svg";
import TriangularDown from "../assets/triangular-bg-mission-down.svg";

import FoundersGuide from "../components/FoundersGuide";

import "./About.css";
import NavLight from "../components/NavLight";
import {meta} from "../assets/meta/meta";
import {CustomMetaHelmet} from "../components/CustomMetaHelmet";

function About() {
    return (
        <main className="about">
            <CustomMetaHelmet meta={meta.about}/>
            <NavLight />
            {/* Intro   */}
            <div className="intro">
                <section className="intro-container">
                    <div className="intro-description">
                        <h1>The easiest way to manage feedback</h1>
                        <p>
                            No more feedback all over the place. No more
                            dependencies on manual work to stay up to date.
                        </p>
                        <p>&nbsp;</p>
                        <p>
                            Welcome to the future of feedback management, where
                            feedback is automatically unified in one place and
                            categorized in real-time by AI. You will love it,
                            and your teams will love you for it.
                        </p>
                        <p>&nbsp;</p>
                        <p>
                            The future of feedback management is here, and it
                            feels like having magical superpowers.
                        </p>
                    </div>
                    <figure>
                        <img
                            src={Team}
                            alt="team of magic feedback"
                            loading="lazy"
                        />
                    </figure>
                </section>
            </div>
            {/* Mission */}
            <img
                src={TriangularUp}
                alt="background grey triangular"
                className="triangular-bg-mission"
            />
            <section className="mission">
                <div className="mission-container">
                    <h2>Mission</h2>
                    <p>
                        Managing user feedback is a dreadful task. But it
                        shouldn’t be.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        It feels great to learn new insights from user feedback.
                        It’s the rush of excitement when you discover something
                        unexpected. It’s the injection of confidence when you
                        validate the direction you have chosen. Feedback is pure
                        gold.
                    </p>
                    <p>&nbsp;</p>
                    <p>But it isn’t being treated like pure gold.</p>
                    <p>&nbsp;</p>
                    <p>
                        Feedback is scattered all over the place, and it keeps
                        piling up. You try to keep up by remembering everything,
                        but it becomes overwhelming. You keep explaining what’s
                        inside of your head, but your team can’t really pick it
                        up the same way.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        So you have to manually organize and analyze all of your
                        feedback. But it feels dreadful, rather than joy.
                        Something you keep falling behind on. Like it’s dragging
                        you down, not pulling you up
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        It’s time to change the way we manage user feedback.
                        It’s time to modernize it. Make technology work for us.
                        Turn everything upside down.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        With Magic Feedback AI, we have done just that. It makes
                        feedback a joy. It pulls you up. It gives your users a
                        voice. It’s feedback management the way it should be –
                        truly magical.
                    </p>
                </div>
            </section>

            <img
                src={TriangularDown}
                alt="background grey triangular"
                className="triangular-bg-mission"
            />
            {/* Founders-History */}
            <section className="founders-history">
                <div className="founders">
                    <h2>The founders</h2>
                    <div className="founders-container">
                        <article className="founders-details">
                            <div className="founder-img">
                                <figure>
                                    <img
                                        src={CEOImg}
                                        alt="CEO of Magic Feedback"
                                    />
                                </figure>
                            </div>
                            <div className="founder-contact">
                                <div className="founder-badge">
                                    <h3>Nima Vali Rajabi</h3>
                                    <div className="badge">
                                        <p>CEO & Co-founder</p>
                                    </div>
                                </div>
                                <div>
                                    <a href="mailto:nima@magicfeedback.io">
                                        nima@magicfeedback.io
                                    </a>
                                </div>
                                <div className="founder-linkedin">
                                    <a
                                        href="https://www.linkedin.com/in/nimavalirajabi/"
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <figure>
                                            <img
                                                src={LinkedinIcon}
                                                alt="Linkedin icon"
                                            />
                                        </figure>
                                    </a>
                                </div>
                            </div>
                        </article>
                        <article className="founders-details">
                            <div className="founder-img">
                                <figure>
                                    <img
                                        src={CTOImg}
                                        alt="CTO of Magic Feedback"
                                    />
                                </figure>
                            </div>
                            <div className="founder-contact">
                                <div className="founder-badge">
                                    <h3>Francisco Arias</h3>
                                    <div className="badge">
                                        <p>CTO & Co-founder</p>
                                    </div>
                                </div>
                                <div>
                                    <a href="mailto:farias@magicfeedback.io">
                                        farias@magicfeedback.io
                                    </a>
                                </div>
                                <div className="founder-linkedin">
                                    <a
                                        target="_blank"
                                        rel="noreferrer"
                                        href="https://www.linkedin.com/in/fariasweb/"
                                    >
                                        <figure>
                                            <img
                                                src={LinkedinIcon}
                                                alt="Linkedin icon"
                                            />
                                        </figure>
                                    </a>
                                </div>
                            </div>
                        </article>
                    </div>
                </div>
                <div className="history">
                    <h2>History</h2>
                    <p>
                        Hi, my name is Nima, and together with my co-founder,
                        Fran, we built the solution we always wished we had.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        Having spent the last 15 years building products in
                        startups, scale-ups, and companies like Google, SAP, and
                        Zalando, we always struggled with how to manage user
                        feedback. It seemed that as long as manual processes
                        were part of managing user feedback, it was doomed to
                        fail.
                    </p>
                    <p>&nbsp;</p>
                    <p>
                        So in 2023, when we saw the developments in the LLM
                        space, we saw an opportunity to build something that
                        could fix user feedback processes once and for all.
                        Building something from the ground up that could
                        eliminate the need for tedious manual processes and
                        democratize access to insights from user feedback.
                    </p>
                </div>
            </section>

            <section className="FoundersGuide">
                <FoundersGuide />
            </section>
            {/*
            <div className="related-blogs">
                 <h1>What we have to say:</h1>
                <BlogsPreview />
            </div>
                */}
        </main>
    );
}

export default About;
